import React from 'react';

import type { Control } from 'react-hook-form';

import TimeFieldComp from '@/components/TimeFieldComp';

/**
 * 起床入力タイプ
 */
export type WakeupInputType = {
  /** 測定日時 */
  measureDateTime: string,
}

/**
 * 入力フォーム
 */
export type WakeupFormInputType = {
  /** コントローラー */
  control: Control<WakeupInputType, never>,
  /** エラー */
  errors: any,
}

const WakeupFormInput: React.FC<WakeupFormInputType> = ({
  control,
  errors,
}) => (
  <div>
    <TimeFieldComp
      control={control}
      name="measureDateTime"
      label="日時"
      rules={{
        required: '必須項目です',
      }}
      errors={errors}
    />
  </div>
);

export default WakeupFormInput;
